import {RoomWs} from "./room.ws";

export class RoomListResponseWs{
    buildingName:string;
    rooms:RoomWs[];
}
